import $ from 'jquery';
import Headroom from 'headroom.js';

const header = document.querySelector('.site-header');
const headroom = new Headroom(header);
headroom.init();

$('.mobile-navigation .menu-item-has-children').prepend(
    '<button type="button" class="dropdown-toggle"><i class="nf-icon-arrow-down"></i></button>'
);

$(document).on('click', '.dropdown-toggle', function () {
    $(this).parent().toggleClass('active').find('ul').first().slideToggle(250);
});

$('.mobile-navigation > .current-menu-ancestor').addClass('active');
$('.mobile-navigation > .current-menu-ancestor').find('.sub-menu').show();

$('.menu-toggle-button').on('click', () => {
    $('body').toggleClass('menu-active');
    $('.mobile-menu').toggleClass('swing-in-top-fwd');
});

$('.sticky-menu-toggle').on('click', () => {
    $('.site-header')
        .removeClass('headroom--unpinned')
        .addClass('headroom--pinned');

    if ($(window).width() <= 1100) {
        $('body').toggleClass('menu-active');
        $('.mobile-menu').toggleClass('swing-in-top-fwd');
    }
});

const fixSiteMainMargin = () => {
    const adminBar = $('#wpadminbar').height();
    const header = $('.site-header').height();

    $('.site-main').css('padding-top', $('.site-header').height());
};

fixSiteMainMargin();

window.onresize = function () {
    fixSiteMainMargin();
};
